import React, { useState, useEffect } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import {
  Button,
  Grid,
  Chip,
  Collapse,
  Breadcrumbs,
  Typography,
} from "@material-ui/core";
import ViewListIcon from "@material-ui/icons/ViewList";
import { withStyles, makeStyles, createStyles } from "@material-ui/core/styles";
import { setCurrentPage, getLuckyFarmerNftTrendPageData } from "actions";
import * as C from "components";
import JtcbNftTrendTable from "components/Table/JtcbNftTrendTable";
import * as V from "styles/variables";
import * as H from "helper";
import ChartConfig from "utils/ChartConfig";

const useStyles = makeStyles((theme) =>
  createStyles({
    loaderBoxForUnique: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 110,
    },
    loaderBox: {
      width: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: 280,
    },
    loaderBarImg: {
      width: 40,
    },
    filterSection: {
      display: "flex",
      backgroundColor: "#fafafa",
      zIndex: 1000,
      paddingTop: 16,
      paddingLeft: 8,
      marginTop: -12,
    },
    dataBtn: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(2),
      height: theme.spacing(4),
      color: V.btnLabelColor,
    },
    activeUsersTable: {
      padding: 16,
      borderSpacing: 0,
    },
    autoSelect: {
      marginTop: 8,
      marginLeft: 16,
    },
    totalBox: {
      fontSize: 16,
    },
    summarySection: {
      marginTop: theme.spacing(2),
      marginLeft: theme.spacing(5),
      fontSize: 14,
    },
    summaryBox: {
      paddingLeft: 16,
      borderRight: "1px solid #dcdcdc",
    },
    gridSection: {
      marginTop: theme.spacing(1),
    },
    selectGameTxt: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      minHeight: 280,
      flexWrap: "wrap",
      "& > *": {
        margin: theme.spacing(0.5),
      },
    },
    expand: {
      marginLeft: "auto",
      marginRight: 32,
    },
    title: {
      fontSize: 18,
      marginLeft: 36,
      marginTop: 16,
    },
    rareTitle: {
      marginBottom: 8,
    },
  })
);

const PicTreeSalesTrend = ({
  setCurrentPage,
  getLuckyFarmerNftTrendPageData,
  trendDataLoading,
  trendDataCountAuction,
  trendDataAmountAuction,
  trendDataCountStore,
  trendDataAmountStore,
  nftTrendDataAuctionAll,
  nftTrendDataStoreAll,
  trendDataCountStoreFiat,
  trendDataAmountStoreFiat,
  nftTrendDataStoreAllFiat,
}) => {
  const classes = useStyles();
  const [btnStateDataFetch, setBtnState] = useState(true);
  const [chartData, setChartData] = useState([]);
  const [storeData, setStoreData] = useState([]);
  const [storeDataFiat, setStoreDataFiat] = useState([]);

  // expand
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    setCurrentPage(window.location.pathname);
    getLuckyFarmerNftTrendPageData();
  }, []);

  useEffect(() => {
    // combine data
    const dataCombined = trendDataCountAuction.concat(trendDataAmountAuction);
    setChartData(dataCombined);
  }, [trendDataCountAuction, trendDataAmountAuction]);

  useEffect(() => {
    // combine data
    const dataCombinedStore = trendDataCountStore.concat(trendDataAmountStore);
    setStoreData(dataCombinedStore);
  }, [trendDataCountStore, trendDataAmountStore]);

  useEffect(() => {
    // combine data
    const dataCombinedStoreFiat = trendDataCountStoreFiat.concat(
      trendDataAmountStoreFiat
    );
    setStoreDataFiat(dataCombinedStoreFiat);
  }, [trendDataCountStoreFiat, trendDataAmountStoreFiat]);

  const getAveValue = (amount, count) => {
    let dataToReturn =
      parseFloat(amount.replace(/,/g, "")) /
      parseFloat(count.replace(/,/g, ""));
    dataToReturn = dataToReturn.toFixed(0);
    return H.FormatNumStrHelper.formatCommaThousand(dataToReturn);
  };

  const fetchData = () => {
    getLuckyFarmerNftTrendPageData();
    setBtnState(!btnStateDataFetch);
  };

  return (
    <C.ContentWrapper>
      <div className={classes.filterSection}>
        <Grid
          container
          spacing={0}
          direction="row"
          justifyContent="space-between"
        >
          <Grid item>
            <Breadcrumbs separator="›" className={classes.breadcrumbs}>
              <Typography>PicTrée</Typography>
              <Typography variant="body1">課金・報酬</Typography>
              <Typography variant="body1">NFT取引トレンド</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid item>
            <Grid container spacing={0} direction="row">
              <Grid item>
                <C.CalendarRangeOnly
                  setBtnState={setBtnState}
                  page="PicTreerNftTrend"
                />
              </Grid>
              <Grid>
                <Button
                  className={classes.dataBtn}
                  variant="contained"
                  color="primary"
                  onClick={() => fetchData()}
                >
                  GO
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>

      <Grid
        container
        spacing={1}
        direction="row"
        className={classes.summarySection}
      >
        <Grid item xs={12} className={classes.totalBox}>
          オークション取引　件数: {nftTrendDataAuctionAll.count}&nbsp;&nbsp;|
          &nbsp;&nbsp;DEP: {nftTrendDataAuctionAll.amount}&nbsp;&nbsp;|
          &nbsp;&nbsp;ユニーク: {nftTrendDataAuctionAll.unique}&nbsp;&nbsp;|
          &nbsp;&nbsp;ユニークDEP平均:{" "}
          {nftTrendDataAuctionAll.unique === "-"
            ? "-"
            : getAveValue(
                nftTrendDataAuctionAll.amount,
                nftTrendDataAuctionAll.unique
              )}
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        direction="row"
        className={classes.summarySection}
      >
        <Grid item xs={12} md={6} lg={3} className={classes.summaryBox}>
          <div className={classes.rareTitle}>
            <Chip
              size="small"
              label="オークション"
              style={{
                color: "#fff",
                backgroundColor: V.genericColorPallette[0],
              }}
            />
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={1} className={classes.gridSection}>
        <Grid item xs={12} md={12} lg={12}>
          {trendDataLoading ? (
            <div className={classes.loaderBox}>
              <img
                className={classes.loaderBarImg}
                src={`/static/images/loader-bar.gif`}
              />
            </div>
          ) : chartData.length > 0 ? (
            <C.LineChartNftDepTrend
              title=""
              legend={ChartConfig.cookinBurgerNftTrend}
              lblSaveImage={"DEP取引種別"}
              xAisData={chartData[0]["date"]}
              seriesData={chartData}
              chartType={"line"}
            />
          ) : (
            <div className={classes.selectGameTxt}>
              <Chip
                label="No Data"
                style={{
                  color: V.textColor,
                  backgroundColor: V.placeholderColor,
                }}
              />
            </div>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={1} className={classes.gridSection}>
        <Button
          className={classes.expand}
          onClick={handleExpandClick}
          startIcon={<ViewListIcon />}
          size="small"
        >
          表データを{expanded ? "非表示にする" : "表示する"}
        </Button>
      </Grid>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div className={classes.activeUsersTable}>
          <JtcbNftTrendTable
            title="オークション販売"
            dataCount={trendDataCountAuction}
            dataAmount={trendDataAmountAuction}
          />
        </div>
      </Collapse>

      <Grid
        container
        spacing={1}
        direction="row"
        className={classes.summarySection}
      >
        <Grid item xs={12} className={classes.totalBox}>
          ストア取引　件数: {nftTrendDataStoreAll.count}
          &nbsp;&nbsp;|&nbsp;&nbsp; DEP: {nftTrendDataStoreAll.amount}
          &nbsp;&nbsp;|&nbsp;&nbsp; ユニーク: {nftTrendDataStoreAll.unique}
          &nbsp;&nbsp;|&nbsp;&nbsp; &nbsp;&nbsp;ユニークDEP平均:{" "}
          {nftTrendDataStoreAll.unique === "-"
            ? "-"
            : getAveValue(
                nftTrendDataStoreAll.amount,
                nftTrendDataStoreAll.unique
              )}
        </Grid>
      </Grid>

      <Grid
        container
        spacing={1}
        direction="row"
        className={classes.summarySection}
      >
        <Grid item xs={12} md={6} lg={3} className={classes.summaryBox}>
          <div className={classes.rareTitle}>
            <Chip
              size="small"
              label="ストア"
              style={{
                color: "#fff",
                backgroundColor: V.genericColorPallette[1],
              }}
            />
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={1} className={classes.gridSection}>
        <Grid item xs={12} md={12} lg={12}>
          {trendDataLoading ? (
            <div className={classes.loaderBox}>
              <img
                className={classes.loaderBarImg}
                src={`/static/images/loader-bar.gif`}
              />
            </div>
          ) : chartData.length > 0 ? (
            <C.LineChartNftDepTrend
              title=""
              legend={ChartConfig.cookinBurgerNftTrend}
              lblSaveImage={"DEP取引種別"}
              xAisData={storeData[0]["date"]}
              seriesData={storeData}
              chartType={"line"}
            />
          ) : (
            <div className={classes.selectGameTxt}>
              <Chip
                label="No Data"
                style={{
                  color: V.textColor,
                  backgroundColor: V.placeholderColor,
                }}
              />
            </div>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={1} className={classes.gridSection}>
        <Button
          className={classes.expand}
          onClick={handleExpandClick}
          startIcon={<ViewListIcon />}
          size="small"
        >
          表データを{expanded ? "非表示にする" : "表示する"}
        </Button>
      </Grid>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div className={classes.activeUsersTable}>
          <JtcbNftTrendTable
            title="ストア販売"
            dataCount={trendDataCountStore}
            dataAmount={trendDataAmountStore}
          />
        </div>
      </Collapse>

      {/* FIAT */}
      <Grid
        container
        spacing={1}
        direction="row"
        className={classes.summarySection}
      >
        <Grid item xs={12} className={classes.totalBox}>
          ストアFIAT取引　件数: {nftTrendDataStoreAllFiat.count}
          &nbsp;&nbsp;|&nbsp;&nbsp; USD: {nftTrendDataStoreAllFiat.amount}
          &nbsp;&nbsp;|&nbsp;&nbsp; ユニーク: {nftTrendDataStoreAllFiat.unique}
          &nbsp;&nbsp;|&nbsp;&nbsp; &nbsp;&nbsp;ユニークUSD平均:{" "}
          {nftTrendDataStoreAllFiat.unique === "0" ||
          nftTrendDataStoreAllFiat.unique === "-"
            ? "-"
            : getAveValue(
                nftTrendDataStoreAllFiat.amount,
                nftTrendDataStoreAllFiat.unique
              )}
        </Grid>
      </Grid>

      <Grid container spacing={1} className={classes.gridSection}>
        <Grid item xs={12} md={12} lg={12}>
          {trendDataLoading ? (
            <div className={classes.loaderBox}>
              <img
                className={classes.loaderBarImg}
                src={`/static/images/loader-bar.gif`}
              />
            </div>
          ) : chartData.length > 0 ? (
            <C.LineChartNftDepTrend
              title=""
              legend={ChartConfig.cookinBurgerNftTrendFiat}
              lblSaveImage={"USD取引種別"}
              xAisData={storeDataFiat[0]["date"]}
              seriesData={storeDataFiat}
              chartType={"line"}
              currency="USD"
            />
          ) : (
            <div className={classes.selectGameTxt}>
              <Chip
                label="No Data"
                style={{
                  color: V.textColor,
                  backgroundColor: V.placeholderColor,
                }}
              />
            </div>
          )}
        </Grid>
      </Grid>
      <Grid container spacing={1} className={classes.gridSection}>
        <Button
          className={classes.expand}
          onClick={handleExpandClick}
          startIcon={<ViewListIcon />}
          size="small"
        >
          表データを{expanded ? "非表示にする" : "表示する"}
        </Button>
      </Grid>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <div className={classes.activeUsersTable}>
          <JtcbNftTrendTable
            title="ストアFIAT販売"
            dataCount={trendDataCountStoreFiat}
            dataAmount={trendDataAmountStoreFiat}
          />
        </div>
      </Collapse>
    </C.ContentWrapper>
  );
};

PicTreeSalesTrend.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  trendDataLoading: state.luckyFarmerNftTrend.luckyFarmerNftTrendDateLoading,
  trendData: state.luckyFarmerNftTrend.trendData,
  trendDataCountAuction: state.luckyFarmerNftTrend.nftTrendDataCountAuction,
  trendDataAmountAuction: state.luckyFarmerNftTrend.nftTrendDataAmountAuction,
  trendDataCountStore: state.luckyFarmerNftTrend.nftTrendDataCountStore,
  trendDataAmountStore: state.luckyFarmerNftTrend.nftTrendDataAmountStore,
  trendDataCountStoreFiat: state.luckyFarmerNftTrend.nftTrendDataCountStoreFiat,
  trendDataAmountStoreFiat: state.luckyFarmerNftTrend.nftTrendDataAmountStoreFiat,
  nftTrendDataAuctionAll: state.luckyFarmerNftTrend.nftTrendDataAuctionAll,
  nftTrendDataStoreAll: state.luckyFarmerNftTrend.nftTrendDataStoreAll,
  nftTrendDataStoreAllFiat: state.luckyFarmerNftTrend.nftTrendDataStoreAllFiat,
});

const mapDispatchToProps = (dispatch) => ({
  setCurrentPage: (param) => dispatch(setCurrentPage(param)),
  getLuckyFarmerNftTrendPageData: () => dispatch(getLuckyFarmerNftTrendPageData()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(null, { withTheme: true })(PicTreeSalesTrend));
